import {NgModule} from '@angular/core';
import {
    CrCustomerInsurableObjectObjectComponent
} from './component/object-components/cr-customer-insurable-object-object-component/cr-customer-insurable-object-object.component';
import {
    CustomerSignatureTypePagePage
} from './page/overview/customer-signature-type-page/customer-signature-type-page.page';
import {CustomerOnboardingTypePage} from './page/overview/customer-onboarding-type/customer-onboarding-type.page';
import {CustomerWelcomePage} from './page/overview/customer-welcome/customer-welcome.page';
import {CustomerTypePage} from './page/overview/customer-type/customer-type.page';
import {CrDashboardPage} from './page/dashboard/cr-dashboard/cr-dashboard.page';
import {CrCustomerComponent} from './component/protected-components/cr-customer/cr-customer.component';
import {UmModule} from '../../feature-core/um/um.module';
import {
    CrCreateObjectCustomerComponent
} from './component/protected-components/cr-create-object-customer/cr-create-object-customer.component';
import {PmModule} from '../pm/pm.module';
import {DmModule} from '../../feature-core/dm/dm.module';
import {ConfigPage} from './page/overview/config/config.page';
import {
    CrCustomerRelatedPersonsComponent
} from './component/protected-components/cr-customer-related-persons/cr-customer-related-persons.component';
import {
    CrSearchFlexibleCustomerComponent
} from './search/cr-search-flexible-customer/cr-search-flexible-customer.component';
import {
    CrCustomerContractDetailsComponent
} from './component/protected-components/cr-customer-contract-details/cr-customer-contract-details.component';
import {
    CrCustomerPhoneContactAvailabilityComponent
} from './component/protected-components/cr-customer-phone-contact-availability/cr-customer-phone-contact-availability.component';
import {
    CrCustomerCommentsComponent
} from './component/protected-components/cr-customer-comments/cr-customer-comments.component';
import {WfModule} from '../../feature-core/wf/wf.module';
import {TmModule} from '../../feature-core/tm/tm.module';
import {
    CrCustomerPhoneAvailabilityWfProcessStepActivityComponent
} from './component/protected-components/wf/cr-customer-phone-availability-wf-process-step-activity/cr-customer-phone-availability-wf-process-step-activity.component';
import {
    CrCustomerCommentWfProcessStepActivityComponent
} from './component/protected-components/wf/cr-customer-comment-wf-process-step-activity/cr-customer-comment-wf-process-step-activity.component';
import {PcModule} from '../pc/pc.module';
import {EuModule} from '../eu/eu.module';
import {NsModule} from '../../feature-core/ns/ns.module';
// TM-1000001919: provides <ch-customer-timeline-navigation> for the "Hub" nav item.
import {ChModule} from '../ch/ch.module';
// TM-1000002000: the two cw lists under the contract list of the consultant customer page. This is
// the only cw MODULE reference of the cr module — the template addresses <cw-customer-lists> by its
// selector. TM-1000002051: cr-customer-standard-navigation additionally imports the pure cw join builders
// (cw/widget/cw-case-product-line.util.ts: core-only imports, no NgModule), which reach back to nothing in cr.
// Zyklusfrei by construction: the sub-module imports CoreModule and nothing else, and must never import
// CrModule (see its own imports block).
import {CwCustomerListsModule} from '../cw/component/protected-components/cw-customer-lists/cw-customer-lists.module';
// TM-1000002027: the Geldfluss map (<cr-customer-billing-map>, nav item `billingMap` of the customer page).
// A component module of its own keeps these hunks small next to TM-1000002030; its developer test page is
// declared in this module (see the test pages below). Cycle-free: CrCustomerBillingMapModule imports CoreModule
// only and must never import CrModule (BOUND-002).
// @ticket TM-1000002027
import {
    CrCustomerBillingMapModule
} from './component/public-components/cr-customer-billing-map/cr-customer-billing-map.module';
import {CrCustomerObjectPage} from './page/object/cr-customer-object-page/cr-customer-object.page';
import {CustomerSearchPage} from './page/overview/customer-search/customer-search.page';
import {
    CrCreateCustomerContractComponent
} from './component/protected-components/cr-create-customer-contract-component/cr-create-customer-contract.component';
import {ObjectSubBaseComponent} from './component/protected-components/cr-customer/component/object-sub-base.component';
import {
    CrCustomerStandardNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-standard-navigation/cr-customer-standard-navigation.component';
import {
    CrCustomerServiceNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-service-navigation/cr-customer-service-navigation.component';
import {
    CrCustomerRegistrationNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-registration-navigation/cr-customer-registration-navigation.component';
import {
    CrCustomerTicketsWorkflowsNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-tickets-workflows-navigation/cr-customer-tickets-workflows-navigation.component';
import {
    CrCreateCustomerContractObjectComponent
} from './component/protected-components/cr-create-customer-contract-component/object/cr-create-customer-contract-object/cr-create-customer-contract-object.component';
import {
    CrCustomerCommunicationNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-communication-navigation/cr-customer-communication-navigation.component';
import {
    CrCustomerContractsNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-contracts-navigation/cr-customer-contracts-navigation.component';
import {
    CrCustomerInteractionNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-interaction-navigation/cr-customer-interaction-navigation.component';
import {
    CrCustomerAdditionalInformationNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-additional-information-navigation/cr-customer-additional-information-navigation.component';
import {
    CrCustomerDocumentUploadComponent
} from './component/protected-components/cr-customer-document-upload/cr-customer-document-upload.component';
import {
    CrSepaMandateCaptureComponent
} from './component/protected-components/cr-sepa-mandate-capture/cr-sepa-mandate-capture.component';
import {CrCustomerCreatePage} from './page/object/cr-customer-create/cr-customer-create.page';
import {
    CrCustomerRelatedPersonComponent
} from './component/protected-components/cr-customer-related-person/cr-customer-related-person.component';
import {CrCustomerLastPage} from './page/object/cr-customer-last/cr-customer-last.page';
import {CrCreateUserComponent} from './component/protected-components/eu/cr-create-user/cr-create-user.component';
import {CmModule} from '../cm/cm.module';
import {
    CrManageRegistrationWidgetComponent
} from './component/protected-components/cr-manage-registration/cr-manage-registration-widget/cr-manage-registration-widget.component';
import {
    CrManageRegistrationUserComponent
} from './component/protected-components/cr-manage-registration/cr-manage-registration-user/cr-manage-registration-user.component';
import {
    CrManageRegistrationDocumentComponent
} from './component/protected-components/cr-manage-registration/cr-manage-registration-document/cr-manage-registration-document.component';
import {CrRegistrationManageComponent} from './page/overview/cr-registration-manage/cr-registration-manage.component';
import {
    CrCustomerPromoComponent
} from './component/protected-components/cr-customer/component/cr-customer-promo/cr-customer-promo.component';
import {
    CrCreateCustomerEmergencyContactComponent
} from './component/protected-components/cr-create-customer-emergency-contact/cr-create-customer-emergency-contact.component';
import {
    CrCreateEmergencyContactComponent
} from './component/protected-components/cr-customer/component/cr-create-emergency-contact/cr-create-emergency-contact.component';
import {CustomerOverviewPage} from './page/customer-overview-page/customer-overview.page';
import {
    CustomerStatisticsComponent
} from './page/customer-overview-page/components/statisticsComponent/customer-statistics.component';
import {CustomerKpiComponent} from './page/customer-overview-page/components/kpiComponent/customer-kpi.component';
import {CrConfigPage} from './page/overview/cr-config/cr-config.page';
import {
    CrCustomerNewContractsComponent
} from './component/protected-components/cr-customer/component/new-contract-navigation/cr-customer-new-contracts.component';
import {
    ContractsRelationshipsComponent
} from './component/protected-components/cr-customer/component/new-contract-navigation/components/contracts-relationships/contracts-relationships.component';
import {
    CustomerPersonHouseholdComponent
} from './page/object/cr-customer-object-page/component/pm-household/customer-person-household.component';
import {
    CheckCustomerHouseholdComponent
} from './component/protected-components/cr-customer/component/cr-customer-standard-navigation/component/check-person-household/check-customer-household.component';
import {
    CheckIsPersonCustomerComponent
} from './component/protected-components/cr-customer/component/cr-customer-standard-navigation/component/check-is-person-customer/check-is-person-customer.component';
import {
    CrCustomerExternalIdsComponent
} from './component/protected-components/cr-customer/component/cr-customer-external-ids/cr-customer-external-ids.component';
import {
    CrCustomerAppointmentsComponent
} from './component/protected-components/cr-customer/component/cr-customer-appointments/cr-customer-appointments.component';
import {
    CrCustomerInteractionInlineComponent
} from './component/protected-components/cr-customer-interaction-inline-component/cr-customer-interaction-inline-component';
import {
    CrManageRegistrationToolingAreaComponent
} from './component/protected-components/cr-manage-registration/cr-manage-registration-tooling-area/cr-manage-registration-tooling-area.component';
import {
    CrCustomerManageContractsComponent
} from './component/protected-components/cr-customer-manage-contracts/cr-customer-manage-contracts.component';
import {
    CrManagePendingInsurancesComponent
} from './component/protected-components/cr-manage-registration/cr-manage-pending-insurances/cr-manage-pending-insurances.component';

import {
    CrRegistrationToolingTicketViewerComponent
} from './component/protected-components/cr-manage-registration/cr-manage-registration-tooling-area/components/registration-tooling-ticket-viewer/cr-registration-tooling-ticket-viewer.component';
import {CustomerSpecificPage} from './page/customer-specific-page/customer-specific.page';
import {
    CustomerContractDetailComponent
} from './page/customer-specific-page/components/customer-contract-detail-component/customer-contract-detail.component';
import {
    CrCustomerHeaderComponent
} from './component/protected-components/cr-customer/component/cr-customer-header/cr-customer-header.component';
import {
    CrToolPanelComponent
} from './page/customer-specific-page/components/tool-panel-component/cr-tool-panel.component';
import {
    CrCustomerCallHistory
} from './page/customer-specific-page/components/cr-customer-call-history/cr-customer-call-history';
import {NgOptimizedImage} from '@angular/common';
import {
    CrCreateCustomerDetailComponent
} from './component/protected-components/cr-create-customer-detail/cr-create-customer-detail.component';
import {
    CustomerSpecificImageViewer
} from './page/customer-specific-page/components/customer-specific-image-viewer/customer-specific-image-viewer.component';
import {CustomerAssessmentPage} from './page/customer-assessment-page/customer-assessment-page.component';
import {
    CrAssessmentComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/cr-assessment.component';
import {
    CrAssessmentHeaderComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment-header/cr-assessment-header.component';
import {
    CrCustomerProfileCheckComponent
} from './component/protected-components/cr-customer-profile-check/cr-customer-profile-check.component';
import {SmartGuideComponent} from './page/customer-assessment-page/components/smart-guide/smart-guide.component';
import {
    CrHouseholdInsuredObjectsComponent
} from './page/customer-assessment-page/components/cr-houshlod-insured-objects/cr-household-insured-objects.component';
import {
    CrAssessmentPersonalInfoComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-personal-info/cr-assessment-personal-info.component';
import {
    CrAssessmentSessionBaseComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/assessment-base-component/cr-assessment-session-base.component';
import {
    CrAssessmentHouseholdComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-household/cr-assessment-household.component';
import {
    CrAssessmentInsuredObjectsComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-insured-objects/cr-assessment-insured-objects.component';
import {
    CrAssessmentContractsComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-contracts/cr-assessment-contracts.component';
import {
    CrAssessmentContractsTemplateComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-contracts/components/cr-assessment-contracts-template/cr-assessment-contracts-template.component';
import {
    RelationTypeTemplateComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-household/components/relation-type-template/relation-type-template.component';
import {
    CrAssessmentFinaliseComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-finalise/cr-assessment-finalise.component';
import {
    CrAssessmentToolPanelComponent
} from './page/customer-specific-page/components/cr-assessment-tool-panel/cr-assessment-tool-panel.component';
import {
    AssessmentPersonSearchComponent
} from './page/customer-assessment-page/components/assessment/cr-assessment/components/assessment-person-search-component/assessment-person-search.component';
import {CR_TEST_PROVIDERS} from './test/cr-test-definition';
import {CR_ENTITY_PROVIDER} from './cr.entity-provider';
import {
    CrCustomerInlineComponent
} from './component/protected-components/cr-customer-inline-component/cr-customer-inline-component';
import {
    CrCustomerInteractionObjectComponent
} from './component/protected-components/cr-customer-interaction-object-component/cr-customer-interaction-object.component';
import {CoreModule} from '../../core/core.module';
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';
import {UiModule} from '../../core/ui/ui.module';
import {PMessagesComponent} from '../../core/shared/p-messages/p-messages.component';
import {
    CustomerSpecificComponent
} from './page/customer-specific-page/customer-specific-component/customer-specific.component';
import {
    CrCustomerObjectConsultantPage
} from './page/consultant-page/object/cr-customer-object-page/cr-customer-object-consultant.page';
import {
    CrCustomerConsultantComponent
} from './component/protected-components/consultant-component/cr-customer/cr-customer-consultant.component';
import {
    CrCustomerStandardNavigationConsultantComponent
} from './component/protected-components/consultant-component/cr-customer/component/cr-customer-standard-navigation-consultant/cr-customer-standard-navigation-consultant.component';
import {MyCustomersPage} from './page/consultant-page/my-customers-page/my-customers.page';
import {
    CrCustomerTicketsComponent
} from './component/protected-components/consultant-component/cr-customer-tickets/cr-customer-tickets.component';
import {
    CustomerOverviewConsultantPage
} from './page/consultant-page/customer-overview-page/customer-overview-consultant.page';
import {
    OverviewComponent
} from './page/consultant-page/customer-overview-page/components/overview-component/overview.component';
import {
    AppDisplayDetailComponent
} from './page/consultant-page/customer-overview-page/components/app-display-detail/app-display-detail.component';
import {
    AppDisplayDetailListComponent
} from './page/consultant-page/customer-overview-page/components/app-display-detail-list/app-display-detail-list.component';
import {
    CrCustomerCommunicationNavigationConsultantComponent
} from './component/protected-components/consultant-component/cr-customer/component/cr-customer-communication-navigation-consultant/cr-customer-communication-navigation-consultant.component';
import {
    CrCustomerHeaderConsultantComponent
} from './component/protected-components/consultant-component/cr-customer/component/cr-customer-header-consultant/cr-customer-header-consultant.component';
import {
    CrCustomerServiceNavigationConsultantComponent
} from './component/protected-components/consultant-component/cr-customer/component/cr-customer-service-navigation-consultant/cr-customer-service-navigation-consultant.component';
import {
    CrCustomerDocumentUploadConsultantComponent
} from './component/protected-components/consultant-component/cr-customer-document-upload/cr-customer-document-upload-consultant.component';
import {BmModule} from '../../feature-bm/bm/bm.module';
import {
    CustomerObjectBaseComponent
} from './component/protected-components/cr-customer/view/customer-object-base.component';
import {
    CrCustomerObjectFullComponent
} from './component/protected-components/cr-customer/view/cr-customer-navigation-item-full/cr-customer-object-full.component';
import {CrAddressWizardPage} from './page/object/cr-address-wizard-page/cr-address-wizard.page';
import {
    CrCustomerAddressObjectComponent
} from './component/object-components/cr-customer-address-object-component/cr-customer-address-object.component';
import {
    CrWizardStepAddressComponent
} from './component/protected-components/cr-customer-address-wizard/cr-wizard-step-address/cr-wizard-step-address.component';
import {
    CrWizardStepCreateInsurableComponent
} from './component/protected-components/cr-customer-address-wizard/cr-wizard-step-create-insurable/cr-wizard-step-create-insurable.component';
import {
    CrWizardStepNotificationsComponent
} from './component/protected-components/cr-customer-address-wizard/cr-wizard-step-notifications/cr-wizard-step-notifications.component';
import {
    CrWizardStepSummaryComponent
} from './component/protected-components/cr-customer-address-wizard/cr-wizard-step-summary/cr-wizard-step-summary.component';
// TM-1000002008: the Adress-Assistent's wrapper around the shared cr-object-contracts
import {
    CrWizardContractsViewComponent
} from './component/protected-components/cr-customer-address-wizard/cr-wizard-contracts-view/cr-wizard-contracts-view.component';
import {CustomerAiPlaygroundPage} from './page/overview/customer-ai-playground-page/customer-ai-playground.page';
// „Kunden in meiner Nähe": the shared map + distance-list component and its two page shells
// (shell-alpha overview page, shell-consultant page). The component needs FormsModule ([(ngModel)]),
// the PrimeNG autocomplete/table/button/message/skeleton modules and <mvs-tomtom-component> - all
// of them reach this module through CoreModule -> SharedModule (exported there).
import {
    CrNearbyCustomersComponent
} from './component/protected-components/cr-nearby-customers/cr-nearby-customers.component';
import {CrNearbyCustomersPage} from './page/overview/cr-nearby-customers/cr-nearby-customers.page';
import {
    CrNearbyCustomersConsultantPage
} from './page/consultant-page/cr-nearby-customers-consultant-page/cr-nearby-customers-consultant.page';
import {
    CrCustomerAiPlaygroundComponent
} from './component/protected-components/cr-customer-ai-playground/cr-customer-ai-playground.component';
import {
    CrContractOverviewComponent
} from './component/protected-components/cr-contract-overview/cr-contract-overview.component';
import {CrContractOverviewPage} from './page/object/cr-contract-overview-page/cr-contract-overview.page';
import {
    CrFinancialSummaryComponent
} from './component/shared-components/cr-financial-summary/cr-financial-summary.component';
import {
    CrCustomerBankAccountObjectComponent
} from './component/object-components/cr-customer-bank-account-object-component/cr-customer-bank-account-object.component';
import {
    CrCustomerBankAccountCreateObjectComponent
} from './component/object-components/cr-customer-bank-account-create-object-component/cr-customer-bank-account-create-object.component';
import {
    CrCustomerBankAccountChangeObjectComponent
} from './component/object-components/cr-customer-bank-account-change-object-component/cr-customer-bank-account-change-object.component';
// TM-1000002030: the read-only bank account overview OBC (root, base/full/side views, shared content)
// @ticket TM-1000002030
import {
    CrCustomerBankAccountOverviewObjectComponent
} from './component/object-components/cr-customer-bank-account-overview-object-component/cr-customer-bank-account-overview-object.component';
import {
    CrCustomerBankAccountOverviewBaseComponent
} from './component/object-components/cr-customer-bank-account-overview-object-component/view/base/cr-customer-bank-account-overview-base.component';
import {
    CrCustomerBankAccountOverviewFullComponent
} from './component/object-components/cr-customer-bank-account-overview-object-component/view/full/cr-customer-bank-account-overview-full.component';
import {
    CrCustomerBankAccountOverviewSideComponent
} from './component/object-components/cr-customer-bank-account-overview-object-component/view/side/cr-customer-bank-account-overview-side.component';
import {
    CrCustomerBankAccountOverviewComponent
} from './component/object-components/cr-customer-bank-account-overview-object-component/shared/cr-customer-bank-account-overview/cr-customer-bank-account-overview.component';
import {
    CrWizardStepBankAccountComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-bank-account/cr-wizard-step-bank-account.component';
import {
    CrWizardStepValidFromComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-valid-from/cr-wizard-step-valid-from.component';
import {
    CrWizardStepReplacedBankAccountsComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-replaced-bank-accounts/cr-wizard-step-replaced-bank-accounts.component';
import {
    CrWizardStepBankChangeConfirmationComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-bank-change-confirmation/cr-wizard-step-bank-change-confirmation.component';
import {
    CrWizardStepBankChangeNotificationComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-bank-change-notification/cr-wizard-step-bank-change-notification.component';
import {
    CrWizardStepBankChangePartnerNotificationComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-bank-change-partner-notification/cr-wizard-step-bank-change-partner-notification.component';
import {
    CrCustomerBankAccountWizardComponent
} from './component/protected-components/cr-bank-account-wizard/cr-customer-bank-account-wizard/cr-customer-bank-account-wizard.component';
import {
    CrWizardStepBankAccountSummaryComponent
} from './component/protected-components/cr-bank-account-wizard/cr-wizard-step-bank-account-summary/cr-wizard-step-bank-account-summary.component';
import {
    CrEiCandidateRendererComponent
} from './component/protected-components/cr-ei-candidate-renderer/cr-ei-candidate-renderer.component';
import {CR_EI_RENDERER_PROVIDER} from './cr-ei-renderer.provider';
import {CR_WF_ACTIVITY_PROVIDER} from './cr-wf-activity.provider';
import {
    CustomerFormTypeObjectComponent
} from './component/protected-components/object-component/customer-form-type-object-component/customer-form-type-object.component';
import {CrFormConfigPage} from './page/overview/cr-form-config/cr-form-config-page.component';
import {CustomerExternalAliasPage} from './page/overview/customer-external-alias/customer-external-alias.page';
import {CustomerFormTypePage} from './page/overview/customer-form-type/customer-form-type.page';
import {CustomerInteractionTypePage} from './page/overview/customer-interaction-type/customer-interaction-type.page';
import {CustomerNotificationTypePage} from './page/overview/customer-notification-type/customer-notification-type.page';
import {
    ConsultationGuideLauncherComponent
} from './component/consultation-guide-launcher/consultation-guide-launcher.component';
import {
    CrCustomerQuickActionsComponent
} from './component/protected-components/cr-customer-quick-actions/cr-customer-quick-actions.component';
import {
    CrCustomerContractReactivationComponent
} from './component/protected-components/cr-customer-contract-reactivation/cr-customer-contract-reactivation.component';
import {
    CrCustomerPaymentStatusComponent
} from './component/public-components/cr-customer-payment-status/cr-customer-payment-status.component';
import {
    CrCustomerRepresentativeBadgeComponent
} from './component/protected-components/cr-customer-representative-badge/cr-customer-representative-badge.component';
import {
    CrCustomerRepresentativesComponent
} from './component/protected-components/cr-customer-representatives/cr-customer-representatives.component';
import {
    CrCustomerRepresentativeWizardComponent
} from './component/object-components/cr-customer-representative-wizard/cr-customer-representative-wizard.component';
import {
    CrCrwStepTypeComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-type/cr-crw-step-type.component';
import {
    CrCrwStepPersonComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-person/cr-crw-step-person.component';
import {
    CrCrwStepPersonCaptureComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-person-capture/cr-crw-step-person-capture.component';
import {
    CrCrwStepRoutingComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-routing/cr-crw-step-routing.component';
import {
    CrCrwStepValidityComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-validity/cr-crw-step-validity.component';
import {
    CrCrwStepSummaryComponent
} from './component/protected-components/cr-customer-representative-wizard/cr-crw-step-summary/cr-crw-step-summary.component';
import {
    CrCustomerConsultationHistoryNavigationComponent
} from './component/protected-components/cr-customer/component/cr-customer-consultation-history-navigation/cr-customer-consultation-history-navigation.component';
import {
    CrObjectContactsComponent
} from './component/protected-components/cr-object-contacts-component/cr-object-contacts.component';
import {
    CrObjectAddressesComponent
} from './component/protected-components/cr-object-addresses-component/cr-object-addresses.component';
import {
    CrCustomerChannelsComponent
} from './component/protected-components/cr-customer-channels/cr-customer-channels.component';
import {
    CrPersonMatrixComponent
} from './component/protected-components/cr-person-matrix/cr-person-matrix.component';
import {
    CrPersonMatrixCellComponent
} from './component/protected-components/cr-person-matrix/cell/cr-person-matrix-cell.component';
import {
    CrPersonMatrixAddColumnComponent
} from './component/protected-components/cr-person-matrix/add-column/cr-person-matrix-add-column.component';
import {
    CrObjectContactsTestPage
} from './page/test/cr-object-contacts-test/cr-object-contacts-test.page';
import {
    CrObjectAddressesTestPage
} from './page/test/cr-object-addresses-test/cr-object-addresses-test.page';
import {
    CrPersonMatrixTestPage
} from './page/test/cr-person-matrix-test/cr-person-matrix-test.page';
import {
    CrObjectBankAccountsComponent
} from './component/public-components/cr-object-bank-accounts-component/cr-object-bank-accounts.component';
import {
    CrObjectBillingAccountsComponent
} from './component/public-components/cr-object-billing-accounts-component/cr-object-billing-accounts.component';
import {
    CrBankAccountUsageComponent
} from './component/protected-components/cr-bank-account-usage/cr-bank-account-usage.component';
import {
    CrCustomerBillingAccountCreateComponent
} from './component/object-components/cr-customer-billing-account-create/cr-customer-billing-account-create.component';
import {
    CrBillingAccountCreateStepBillingRunTypeComponent
} from './component/protected-components/cr-customer-billing-account-create/cr-billing-account-create-step-billing-run-type/cr-billing-account-create-step-billing-run-type.component';
import {
    CrBillingAccountCreateStepPaymentMethodComponent
} from './component/protected-components/cr-customer-billing-account-create/cr-billing-account-create-step-payment-method/cr-billing-account-create-step-payment-method.component';
import {
    CrBillingAccountCreateStepBankAccountComponent
} from './component/protected-components/cr-customer-billing-account-create/cr-billing-account-create-step-bank-account/cr-billing-account-create-step-bank-account.component';
import {
    CrBillingAccountCreateStepSummaryComponent
} from './component/protected-components/cr-customer-billing-account-create/cr-billing-account-create-step-summary/cr-billing-account-create-step-summary.component';
import {
    CrObjectBankAccountsTestPage
} from './page/test/cr-object-bank-accounts-test/cr-object-bank-accounts-test.page';
import {
    CrObjectBillingAccountsTestPage
} from './page/test/cr-object-billing-accounts-test/cr-object-billing-accounts-test.page';
import {
    CrObjectContractsComponent
} from './component/public-components/cr-object-contracts-component/cr-object-contracts.component';
import {
    CrObjectContractsTestPage
} from './page/test/cr-object-contracts-test/cr-object-contracts-test.page';
import {
    CrCustomerPersonsComponent
} from './component/protected-components/cr-customer-persons/cr-customer-persons.component';
import {
    CrCustomerPersonsSuggestionComponent
} from './component/protected-components/cr-customer-persons/suggestion/cr-customer-persons-suggestion.component';
import {
    CrCustomerPersonCreateComponent
} from './component/protected-components/cr-customer-persons/create/cr-customer-person-create.component';
import {
    CrCustomerPersonsTestPage
} from './page/test/cr-customer-persons-test/cr-customer-persons-test.page';
import {
    CrCustomerPersonCompleteComponent
} from './component/protected-components/cr-customer-persons/complete/cr-customer-person-complete.component';
import {
    CrCustomerPersonEditComponent
} from './component/protected-components/cr-customer-persons/edit/cr-customer-person-edit.component';
// TM-1000001991: the source-independent wrapper around <cr-customer-persons>
import {
    CrCustomerExternalPersonsComponent
} from './component/protected-components/cr-customer-external-persons/cr-customer-external-persons.component';
// TM-1000001991: the developer test page that drives the wrapper by hand
import {
    CrCustomerExternalPersonsTestPage
} from './page/test/cr-customer-external-persons-test/cr-customer-external-persons-test.page';
import {
    CrSepaMandateTestPage
} from './page/test/cr-sepa-mandate-test/cr-sepa-mandate-test.page';
import {
    CrCustomerPaymentStatusTestPage
} from './page/test/cr-customer-payment-status-test/cr-customer-payment-status-test.page';
import {
    CrObjectChannelsTestPage
} from './page/test/cr-object-channels-test/cr-object-channels-test.page';
// TM-1000002027: developer test page of the Geldfluss map (route cr/test/billingMap), declared here beside the
// other cr test pages - NOT in CrCustomerBillingMapModule (page/test belongs to the module, not to a component).
// @ticket TM-1000002027
import {
    CrCustomerBillingMapTestPage
} from './page/test/cr-customer-billing-map-test/cr-customer-billing-map-test.page';
// "Abrechnungskonten verschmelzen" wizard (04 §3)
import {
    CrBillingAccountMergeObjectComponent
} from './component/object-components/cr-billing-account-merge-object-component/cr-billing-account-merge-object.component';
import {
    CrMergeStepSelectionComponent
} from './component/protected-components/cr-billing-account-merge/cr-merge-step-selection/cr-merge-step-selection.component';
import {
    CrMergeStepPrimaryComponent
} from './component/protected-components/cr-billing-account-merge/cr-merge-step-primary/cr-merge-step-primary.component';
import {
    CrMergeStepFrequencyComponent
} from './component/protected-components/cr-billing-account-merge/cr-merge-step-frequency/cr-merge-step-frequency.component';
import {
    CrMergeStepSummaryComponent
} from './component/protected-components/cr-billing-account-merge/cr-merge-step-summary/cr-merge-step-summary.component';
import {
    CrMergeStepConfirmationComponent
} from './component/protected-components/cr-billing-account-merge/cr-merge-step-confirmation/cr-merge-step-confirmation.component';

@NgModule({
    declarations: [
        // The ONE SEPA mandate block (projects/sepa_storage R-32). Declaration only: both bank
        // account OBCs that embed it live in this module, and BOUND-001 keeps a protected
        // component non-importable from outside.
        CrSepaMandateCaptureComponent,

        CrCustomerInsurableObjectObjectComponent,
        CustomerSignatureTypePagePage,
        CustomerOnboardingTypePage,
        CustomerWelcomePage,
        CustomerTypePage,
        CrDashboardPage,
        CrCustomerComponent,
        ConfigPage,
        CrCustomerRelatedPersonsComponent,
        CrCreateObjectCustomerComponent,
        CrSearchFlexibleCustomerComponent,
        CrCustomerContractDetailsComponent,
        CrCustomerPhoneContactAvailabilityComponent,
        CrCustomerCommentsComponent,
        CrCustomerPhoneAvailabilityWfProcessStepActivityComponent,
        CrCustomerCommentWfProcessStepActivityComponent,
        CrCustomerObjectPage,
        CustomerSearchPage,
        CrCreateCustomerContractComponent,
        ObjectSubBaseComponent,
        CrCustomerStandardNavigationComponent,
        CrCustomerServiceNavigationComponent,
        CrCustomerCommunicationNavigationComponent,
        CrCustomerRegistrationNavigationComponent,
        CrCustomerTicketsWorkflowsNavigationComponent,
        CrCreateCustomerContractObjectComponent,
        CrCustomerContractsNavigationComponent,
        CrCustomerInteractionNavigationComponent,
        CrCustomerAdditionalInformationNavigationComponent,
        CrCustomerDocumentUploadComponent,
        // CrCustomerCreatePage (route `cr/create`) is DECLARED IN CiModule, not here: its create
        // surface is <ci-customer-create-wizard>, and importing CiModule to reach that element would
        // close a circular NgModule dependency (BOUND-002 — CiModule already imports CrModule).
        CrCustomerRelatedPersonComponent,
        CrCustomerLastPage,
        CrCreateUserComponent,
        CrManageRegistrationWidgetComponent,
        CrManageRegistrationUserComponent,
        CrManageRegistrationDocumentComponent,
        CrRegistrationManageComponent,
        CrCustomerPromoComponent,
        CrCreateCustomerEmergencyContactComponent,
        CrCreateEmergencyContactComponent,
        CustomerOverviewPage,
        CustomerStatisticsComponent,
        CustomerKpiComponent,
        CrConfigPage,
        CrCustomerNewContractsComponent,
        ContractsRelationshipsComponent,
        CustomerPersonHouseholdComponent,
        CheckCustomerHouseholdComponent,
        CheckIsPersonCustomerComponent,

        CrCustomerExternalIdsComponent,
        CrCustomerAppointmentsComponent,
        CrCustomerInteractionInlineComponent,
        CrManageRegistrationToolingAreaComponent,
        CrRegistrationToolingTicketViewerComponent,
        CrCustomerManageContractsComponent,
        CrManagePendingInsurancesComponent,
        CustomerSpecificPage,
        CustomerContractDetailComponent,
        CrCustomerHeaderComponent,
        CrToolPanelComponent,
        CrCustomerCallHistory,
        CrCreateCustomerDetailComponent,
        CustomerSpecificImageViewer,
        CustomerAssessmentPage,
        CrAssessmentComponent,
        CrAssessmentHeaderComponent,
        CrCustomerProfileCheckComponent,
        SmartGuideComponent,
        CrHouseholdInsuredObjectsComponent,

        //assessment components
        CrAssessmentPersonalInfoComponent,
        CrAssessmentSessionBaseComponent,
        CrAssessmentHouseholdComponent,
        CrAssessmentInsuredObjectsComponent,
        CrAssessmentContractsComponent,
        CrAssessmentContractsTemplateComponent,
        RelationTypeTemplateComponent,
        CrAssessmentFinaliseComponent,
        CrAssessmentToolPanelComponent,
        CrAssessmentFinaliseComponent,
        AssessmentPersonSearchComponent,
        CrCustomerInlineComponent,
        CrCustomerInteractionObjectComponent,
        CustomerSpecificComponent,

        //Consultant
        CrCustomerObjectConsultantPage,
        CrCustomerConsultantComponent,
        CrCustomerStandardNavigationConsultantComponent,
        ObjectSubBaseComponent,
        MyCustomersPage,
        CrCustomerTicketsComponent,
        // CrCreateCustomerContractObjectComponent,
        CustomerOverviewConsultantPage,
        OverviewComponent,
        AppDisplayDetailComponent,
        AppDisplayDetailListComponent,
        CrCustomerCommunicationNavigationConsultantComponent,
        CrCustomerHeaderConsultantComponent,
        CrCustomerServiceNavigationConsultantComponent,
        CrCustomerStandardNavigationConsultantComponent,
        CrCustomerDocumentUploadConsultantComponent,
        CustomerObjectBaseComponent,
        CrCustomerObjectFullComponent,

        CrAddressWizardPage,
        CrWizardStepAddressComponent,
        CrWizardStepCreateInsurableComponent,
        CrWizardStepNotificationsComponent,
        CrWizardStepSummaryComponent,
        CrWizardContractsViewComponent,
        CrCustomerAddressObjectComponent,
        CustomerAiPlaygroundPage,
        CrCustomerAiPlaygroundComponent,
        // „Kunden in meiner Nähe" - the shared component and both page shells (shell-alpha, shell-consultant).
        CrNearbyCustomersComponent,
        CrNearbyCustomersPage,
        CrNearbyCustomersConsultantPage,
        CrContractOverviewComponent,
        CrContractOverviewPage,
        CrFinancialSummaryComponent,

        // Bank Account Wizard
        CrCustomerBankAccountObjectComponent,

        // The two bank account OBCs (projects/sepa_storage R-31). Both embed the ONE mandate block
        // CrSepaMandateCaptureComponent and carry no mandate logic of their own.
        CrCustomerBankAccountCreateObjectComponent,
        CrCustomerBankAccountChangeObjectComponent,

        // TM-1000002030: the read-only bank account OVERVIEW OBC, resolved by
        // CustomerBankAccountService.getObjectComponent() for viewType 'overview'. Declaration-only: created
        // dynamically by <mvs-object> (root), the views and the shared content only by its own templates.
        // @ticket TM-1000002030
        CrCustomerBankAccountOverviewObjectComponent,
        CrCustomerBankAccountOverviewBaseComponent,
        CrCustomerBankAccountOverviewFullComponent,
        CrCustomerBankAccountOverviewSideComponent,
        CrCustomerBankAccountOverviewComponent,

        CrWizardStepValidFromComponent,
        CrWizardStepReplacedBankAccountsComponent,
        CrWizardStepBankAccountComponent,
        CrWizardStepBankAccountSummaryComponent,
        CrWizardStepBankChangeConfirmationComponent,
        CrWizardStepBankChangeNotificationComponent,
        CrWizardStepBankChangePartnerNotificationComponent,
        CrCustomerBankAccountWizardComponent,

        // EI Candidate Renderer
        CrEiCandidateRendererComponent,

        // CR Object Components
        CustomerFormTypeObjectComponent,

        // CR Config Sub-pages
        CrFormConfigPage,
        CustomerExternalAliasPage,
        CustomerFormTypePage,
        CustomerInteractionTypePage,
        CustomerNotificationTypePage,

        ConsultationGuideLauncherComponent,

        // TM-1000001998: Quick Actions container of the customer header. Declaration-only —
        // CrCustomerHeaderComponent renders it in component mode via *ngComponentOutlet, so the
        // header template resolves against this module's scope. Not exported: it is a protected
        // component (BOUND-001) and is rendered exclusively from the customer header.
        CrCustomerQuickActionsComponent,

        // „Alle reaktivieren" of the customer quick actions - read, confirmation and writes.
        // Declaration-only: rendered exclusively from CrCustomerQuickActionsComponent.
        CrCustomerContractReactivationComponent,

        // Payment status chip (Zahlstatus) of both customer headers. Declaration-only: it is rendered
        // by CrCustomerHeaderComponent and CrCustomerHeaderConsultantComponent, both declared here.
        CrCustomerPaymentStatusComponent,

        // legalsub: representative chip of both customer headers and the „Vertreter" block of both
        // standard navigations. Declaration-only (protected components, rendered inside CrModule only).
        CrCustomerRepresentativeBadgeComponent,
        CrCustomerRepresentativesComponent,

        // legalsub: the „Vertreter erfassen" wizard (design 04-wizard-design.md part A) - the host plus its six
        // steps. Declaration-only: opened from the customer quick actions (M1) and the „Vertreter" block (M2); the
        // steps are rendered exclusively by the host template.
        CrCustomerRepresentativeWizardComponent,
        CrCrwStepTypeComponent,
        CrCrwStepPersonComponent,
        CrCrwStepPersonCaptureComponent,
        CrCrwStepRoutingComponent,
        CrCrwStepValidityComponent,
        CrCrwStepSummaryComponent,

        CrCustomerConsultationHistoryNavigationComponent,
        CrObjectContactsComponent,
        CrObjectAddressesComponent,
        CrCustomerChannelsComponent,
        CrObjectBankAccountsComponent,
        CrObjectBillingAccountsComponent,
        // "Verwendung durch Abrechnungskonten" of one bank account (bank-slice usage, cr -> bm read).
        CrBankAccountUsageComponent,
        CrObjectContractsComponent,

        // the billing account create flow - the host plus its four steps. The steps are
        // declaration-only, they are rendered exclusively by the host template.
        CrCustomerBillingAccountCreateComponent,
        CrBillingAccountCreateStepBillingRunTypeComponent,
        CrBillingAccountCreateStepPaymentMethodComponent,
        CrBillingAccountCreateStepBankAccountComponent,
        CrBillingAccountCreateStepSummaryComponent,

        // the person matrix and its two sub components
        CrPersonMatrixComponent,
        CrPersonMatrixCellComponent,
        CrPersonMatrixAddColumnComponent,

        // The customer person list and its four sub components. The host is exported below - it is a
        // reusable component and another module may legitimately host it. The four sub components are
        // declaration-only and deliberately NOT exported: the suggestion panel, the create surface and
        // the two write dialogs are reached exclusively through CrCustomerPersonsComponent, which owns
        // the delivery, the match and the reference seam. Exporting any of them would invite a caller
        // that renders part of that contract without the rest.
        CrCustomerPersonsComponent,
        CrCustomerPersonsSuggestionComponent,
        CrCustomerPersonCreateComponent,
        // the completion dialog, declaration-only and deliberately NOT exported for the same
        // reason as the suggestion panel and the create surface above: it is reached exclusively
        // through CrCustomerPersonsComponent, which owns the delivery, the match and the write
        // path. Exporting it would invite a caller that opens the dialog without that contract.
        CrCustomerPersonCompleteComponent,
        // the edit dialog - the completion dialog's SISTER, with the opposite pre-fill rule: the one
        // above fills named gaps and pre-fills nothing, this one corrects what is there and pre-fills
        // everything. Both class docs state why that difference must survive; see
        // CrCustomerPersonEditComponent. Declaration-only and not exported for the same reason.
        CrCustomerPersonEditComponent,

        // TM-1000001991: the source-independent wrapper around the list above. Declared here and
        // exported below - it embeds CrCustomerPersonsComponent and adds the delivery, the match
        // and the provenance on top, so it is the component a host outside cr renders.
        CrCustomerExternalPersonsComponent,

        // Routed developer test pages - declared only, never embedded and never exported.
        CrObjectContactsTestPage,
        CrObjectAddressesTestPage,
        CrPersonMatrixTestPage,
        CrObjectBankAccountsTestPage,
        CrObjectBillingAccountsTestPage,
        CrObjectContractsTestPage,
        CrCustomerPersonsTestPage,
        CrCustomerExternalPersonsTestPage,
        CrSepaMandateTestPage,
        CrCustomerPaymentStatusTestPage,
        CrObjectChannelsTestPage,
        CrCustomerBillingMapTestPage, // TM-1000002027: renders <cr-customer-billing-map> from CrCustomerBillingMapModule

        // "Abrechnungskonten verschmelzen" wizard (04 §3) — host + five steps
        CrBillingAccountMergeObjectComponent,
        CrMergeStepSelectionComponent,
        CrMergeStepPrimaryComponent,
        CrMergeStepFrequencyComponent,
        CrMergeStepSummaryComponent,
        CrMergeStepConfirmationComponent,

    ],
    exports: [
        CrCustomerInsurableObjectObjectComponent,
        CustomerSignatureTypePagePage,
        CustomerOnboardingTypePage,
        CustomerWelcomePage,
        CustomerTypePage,
        CrDashboardPage,
        CrCustomerComponent,
        ConfigPage,
        CrCustomerRelatedPersonsComponent,
        CrCreateObjectCustomerComponent,
        CrSearchFlexibleCustomerComponent,
        CrCustomerContractDetailsComponent,
        CrCustomerPhoneContactAvailabilityComponent,
        CrCustomerCommentsComponent,
        CrCustomerPhoneAvailabilityWfProcessStepActivityComponent,
        CrCustomerCommentWfProcessStepActivityComponent,
        CrCustomerObjectPage,
        CustomerSearchPage,
        CrCreateCustomerContractComponent,
        ObjectSubBaseComponent,
        CrCustomerStandardNavigationComponent,
        CrCustomerServiceNavigationComponent,
        CrCustomerCommunicationNavigationComponent,
        CrCustomerRegistrationNavigationComponent,
        CrCustomerTicketsWorkflowsNavigationComponent,
        CrCreateCustomerContractObjectComponent,
        CrCustomerContractsNavigationComponent,
        CrCustomerInteractionNavigationComponent,
        CrCustomerAdditionalInformationNavigationComponent,
        CrCustomerDocumentUploadComponent,
        // CrCustomerCreatePage moved to CiModule — see the note in `declarations` above.
        CrCustomerRelatedPersonComponent,
        CrCustomerLastPage,
        CrCreateUserComponent,
        CrManageRegistrationWidgetComponent,
        CrManageRegistrationUserComponent,
        CrManageRegistrationDocumentComponent,
        CrRegistrationManageComponent,
        CrCreateCustomerEmergencyContactComponent,
        CrCreateEmergencyContactComponent,
        CrConfigPage,
        CrCustomerNewContractsComponent,
        ContractsRelationshipsComponent,
        CustomerPersonHouseholdComponent,
        CheckCustomerHouseholdComponent,
        CheckIsPersonCustomerComponent,
        CrCustomerInteractionInlineComponent,
        CrManageRegistrationToolingAreaComponent,
        CustomerSpecificPage,
        CustomerContractDetailComponent,
        CrCustomerHeaderComponent,
        CrToolPanelComponent,
        CrCustomerCallHistory,
        CrCreateCustomerDetailComponent,
        CustomerSpecificImageViewer,
        CustomerAssessmentPage,
        CrAssessmentComponent,
        CrAssessmentHeaderComponent,
        CrCustomerProfileCheckComponent,
        SmartGuideComponent,
        CrHouseholdInsuredObjectsComponent,

        //assessment components
        CrAssessmentPersonalInfoComponent,
        CrAssessmentContractsTemplateComponent,
        RelationTypeTemplateComponent,
        CrAssessmentFinaliseComponent,
        CrAssessmentToolPanelComponent,
        CrAssessmentFinaliseComponent,
        AssessmentPersonSearchComponent,

    //     Consultant
        CrCustomerObjectConsultantPage,
        CrCustomerConsultantComponent,
        CrCustomerStandardNavigationConsultantComponent,
        ObjectSubBaseComponent,
        MyCustomersPage,
        CrCustomerTicketsComponent,
        CustomerOverviewConsultantPage,
        CustomerAiPlaygroundPage,
        CrCustomerAiPlaygroundComponent,
        // „Kunden in meiner Nähe" - both page shells (shell-alpha, shell-consultant), exported like the
        // sibling pages above. The shared CrNearbyCustomersComponent is declared only: both pages
        // live in this module and nothing outside CrModule embeds it (BOUND-001).
        CrNearbyCustomersPage,
        CrNearbyCustomersConsultantPage,
        CrContractOverviewComponent,
        CrContractOverviewPage,
        CrFinancialSummaryComponent,

        ConsultationGuideLauncherComponent,
        CrObjectContactsComponent,
        CrObjectAddressesComponent,

        // The communication channel matrix. Exported alongside the two lists above and for the same
        // reason: it is a REUSABLE block, not a screen - the customer page, the consultant view and
        // the cr test page all mount the same component, and a caller outside CrModule is expected
        // rather than hypothetical. Should it ever settle as a purely internal list, the correct move
        // is the one the note below prescribes - back to a non exported declaration - not a second
        // copy of it somewhere else.
        CrCustomerChannelsComponent,

        // BOUND-001 baseline rule: CrObjectContactsComponent / CrObjectAddressesComponent above
        // are exported because they ARE embedded from outside (ci-customer-create-wizard,
        // cw-case-object-step-...) - a load-bearing exception, not a precedent to copy. Should a
        // foreign consumer for a protected list ever appear, the correct move is into
        // component/public-components/, not an export out of protected-components/.
        //
        // [TM-1000001988 overnight C, 2026-09-05] — THE CONTRACT LIST'S FOREIGN CONSUMER APPEARED, and
        // it was resolved the way the sentence above prescribes: „Should a foreign consumer
        // for the contract list ever appear, the correct move is into component/public-components/,
        // not an export out of protected-components/." Arm 3 of the ci post-import pipeline
        // (<ci-case-alignment-failure>) mounts <cr-object-contracts> under the customer its embedded
        // body resolved, so CrObjectContractsComponent MOVED to component/public-components/ — a
        // depth-identical move, not one internal import path changed, exactly as
        // CrObjectBillingAccountsComponent below did when the ci payment-account list needed it — and
        // is exported from there. See the entry beside that one.

        // BOUND-001, resolved the same correct way - fourth occurrence [cw Vorvertrag-Erweiterung / R2.4]: the cw
        // Vorvertrag step shows the Zahlungsstatus of the Vorgang's customer, so <cr-customer-payment-status> got a
        // foreign consumer. It was MOVED to component/public-components/ (depth-identical move, no internal path
        // changed) and is exported from there — not exported out of protected-components/.
        CrCustomerPaymentStatusComponent,

        // BOUND-001, resolved the same correct way - third occurrence: a foreign consumer for this
        // list appeared - the cw payment step picks an existing bank account of the case customer
        // instead of re-implementing the list - so the component was MOVED to
        // component/public-components/ (depth-identical move, no internal path changed) and is
        // exported from there. This is not an export out of protected-components/; it is exactly
        // the move the comment above prescribes and that CrObjectBillingAccountsComponent /
        // CrObjectContractsComponent already made. The move is deliberately made ahead of the
        // consuming step so the boundary is correct before the first foreign import exists.
        // It stays rendered from inside CrModule as well: the cr test page /#/cr/test/bankAccounts
        // and cr-billing-account-create-step-bank-account, which the customer overview reaches
        // through cr-object-billing-accounts -> cr-customer-billing-account-create.
        CrObjectBankAccountsComponent,

        // BOUND-001, resolved the correct way: a foreign consumer DID appear - the ci contract
        // payment-account list embeds this component as phase A of its assignment panel - so the
        // component was MOVED to component/public-components/ (depth-identical move, no internal
        // path changed) and is exported from there. This is not an export out of
        // protected-components/; it is the move that comment above prescribes.
        CrObjectBillingAccountsComponent,

        // [TM-1000001988 overnight C] — exported from component/public-components/ for the same
        // reason and by the same route as the billing-account list above: a consumer outside CrModule
        // renders it. <ci-case-alignment-failure> (ci arm 3) mounts it under the customer its embedded
        // body resolved. See the block above for the move.
        //
        // BOUND-001, resolved the same correct way - second occurrence: a foreign consumer DID
        // appear - <ci-contract-formers> embeds this component as phase A of its former-contract
        // assignment panel, to pick a candidate contract of the same customer - so the component
        // was MOVED to component/public-components/ (depth-identical move, no internal path
        // changed) and is exported from there. This is not an export out of protected-components/;
        // it is exactly the move the comment above prescribes and that
        // CrObjectBillingAccountsComponent already made.
        CrObjectContractsComponent,

        // exported so a host page can open the billing account create run; the four steps stay
        // declaration-only and are never embedded from outside the host.
        CrCustomerBillingAccountCreateComponent,

        // exported so a host page - and later the consultant shell - can embed the matrix without
        // reaching into the module
        CrPersonMatrixComponent,

        // exported so a host page can render <cr-customer-persons> - the reusable half of this
        // feature. Its suggestion panel and its create surface stay declaration-only: they are
        // reached exclusively through this host, never embedded from outside.
        CrCustomerPersonsComponent,

        // TM-1000001991: exported because the screen that HOLDS an external person delivery lives
        // outside this module and has to be able to render <cr-customer-external-persons>.
        CrCustomerExternalPersonsComponent,

        // TM-1000002027: re-exported so <cr-customer-billing-map> (public-components) is available to every
        // module that imports CrModule - the public-components export of matrix §9.1, made through the
        // component module that declares it.
        // @ticket TM-1000002027
        CrCustomerBillingMapModule,
    ],
    imports: [
        CoreModule,
        UmModule,
        PmModule,
        DmModule,
        WfModule,
        TmModule,
        PcModule,
        EuModule,
        NsModule,
        CmModule,
        UiModule,
        NgOptimizedImage,
        PMessagesComponent,
        BmModule,
        ChModule, // TM-1000001919: Communication Hub timeline components
        CwCustomerListsModule, // TM-1000002000: <cw-customer-lists> on the consultant customer page
        CrCustomerBillingMapModule, // TM-1000002027: <cr-customer-billing-map> for the customer nav item `billingMap`
    ],
    providers: [
        CR_TEST_PROVIDERS,
        CR_ENTITY_PROVIDER,
        CR_EI_RENDERER_PROVIDER,
        ...CR_WF_ACTIVITY_PROVIDER,
    ]
})
export class CrModule implements DynamicModule {

    alias = 'cr';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return CustomerKpiComponent;
    }

    getStatisticsComponent() {
        return CustomerStatisticsComponent;
    }

}
